var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCartBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ShoppingCartSimple",
    clipPath: "url(#clip0_501_25235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.22398 2C1.692 2 1.26074 2.44772 1.26074 3C1.26074 3.55228 1.692 4 2.22398 4H3.65915L4.45865 6.98763C4.46349 7.00823 4.46894 7.02858 4.47499 7.04867L6.78182 15.6689C6.9226 16.1952 7.22555 16.6592 7.64435 16.9899C8.06319 17.3206 8.57526 17.4998 9.10148 17.5H18.0271C18.5535 17.5001 19.0654 17.3211 19.4845 16.9904C19.9036 16.6596 20.2069 16.195 20.3478 15.6684L22.6577 7.01713C22.7381 6.71608 22.6784 6.39332 22.4962 6.14466C22.314 5.896 22.0304 5.75 21.7295 5.75H6.12689L5.31934 2.73232C5.20352 2.29952 4.82394 2 4.39126 2H2.22398ZM8.63799 15.1336L6.6621 7.75H20.4629L18.4914 15.1337C18.4632 15.2391 18.4026 15.3319 18.3188 15.3981C18.2349 15.4642 18.1324 15.5 18.0271 15.5H9.10189C8.99665 15.5 8.89432 15.4641 8.81055 15.398C8.72678 15.3318 8.66614 15.2388 8.63799 15.1336ZM8.72582 21.75C9.52379 21.75 10.1707 21.0784 10.1707 20.25C10.1707 19.4216 9.52379 18.75 8.72582 18.75C7.92785 18.75 7.28096 19.4216 7.28096 20.25C7.28096 21.0784 7.92785 21.75 8.72582 21.75ZM18.1174 21.75C18.9153 21.75 19.5622 21.0784 19.5622 20.25C19.5622 19.4216 18.9153 18.75 18.1174 18.75C17.3194 18.75 16.6725 19.4216 16.6725 20.25C16.6725 21.0784 17.3194 21.75 18.1174 21.75Z",
    fill: "#192851"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_501_25235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.1176,
    height: 24,
    fill: "white",
    transform: "translate(0.779297)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartBlack);
export default __webpack_public_path__ + "static/media/ShoppingCartBlack.19a7926e69a6f470af004d280a032ac7.svg";
export { ForwardRef as ReactComponent };